import { CORE_SERVICES } from "../constants";
const initialState = {
  coreData: {},
};
const CoreServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CORE_SERVICES:
      let FinalOutput = { ...state.coreData };
      let ResponseObj = {
        ...{
          isFetching: action.isFetching,
          hasError: action.hasError,
          message: action.message,
          data: action.data,
        },
      };

      if (action.additionSeperator) {
        let actionObj = {
          ...FinalOutput[action.entity],
        };
        actionObj[action.action + "_" + action.additionSeperator] = ResponseObj;
        FinalOutput[action.entity] = actionObj;
      } else {
        let actionObj = { ...FinalOutput[action.entity] };
        actionObj[action.action] = ResponseObj;
        FinalOutput[action.entity] = actionObj;
      }

      return Object.assign({}, state, {
        coreData: FinalOutput,
      });
    default:
      return state;
  }
};

export default CoreServicesReducer;
